/** Federation / Contentstack `microfrontendApp` id for the global header remote. */
export const HEADER_MFE_APP_NAME = 'header_mfe'

export const SSR_RESOURCE = { nameSpace: 'ssr-resource' }

/** Profile home-country code that disables account navigate when live event is off. */
export const HEADER_CN_HOME_COUNTRY = 'CN'

/** CSR / Okta session flag written for Header MFE parity with UserMenu. */
export const IS_AUTHENTICATED_STORAGE_KEY = 'IsAuthenticated'
export const IS_AUTHENTICATED_STORAGE_VALUE = 'true'

/**
 * i18n keys + English fallbacks for header-mfe `authUi`.
 * Keys match legacy UserMenu (`header.welcome`, `header.signIn`, …).
 */
export const HEADER_AUTH_UI_I18N = {
  welcome: { key: 'header.welcome', fallback: 'Hi' },
  signIn: { key: 'header.signIn', fallback: 'Sign In' },
  signUp: { key: 'header.signUp', fallback: 'Sign Up' },
  signOut: { key: 'header.signOut', fallback: 'Sign Out' },
  myAccount: { key: 'header.myAccount', fallback: 'My Account' },
}
